<template>
  <div class="root">
    <p class="fi" :class="classMap">
      <cms-material-icon class="icon" v-if="blok.icon" :icon="blok.icon" :color="blok.icon_color"></cms-material-icon>
      <span class="title">{{ blok.title }}</span>
    </p>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  name: "cms-feature-icon",
  mixins: [cms],
  computed: {
    classMap() {
      return {
        "icon--large": this.blok.icon_size == "large",
        "icon--huge": this.blok.icon_size == "huge",
        "line-breaks": this.blok.line_breaks,
        "row": this.blok.layout == "row",
        "row-reverse": this.blok.layout == "row-reverse",
        "column": this.blok.layout == "column",
        "column-reverse": this.blok.layout == "column-reverse",
      }
    }
  }
}
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
  text-align: center;
  height: 100%;
  font-size: 0.85rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
}

p.fi.row {
  flex-direction: row;
}

p.fi.row-reverse {
  flex-direction: row-reverse;
}

p.fi.column {
  flex-direction: column;
}

p.fi.column-reverse {
  flex-direction: column-reverse;
}

p.fi span.title {
  color: var(--crf-flip);
  white-space: pre-line;
}
p.fi.row span.title {
  text-align: left;
}
p.fi.row-reverse span.title {
  text-align: right;
}

p.fi.icon--large .icon {
  font-size: 2rem;
}

p.fi.icon--huge .icon {
  font-size: 3rem;
}
</style>
